import { SocialNetworksAvailables, User } from '@/hub-shared'
import Button from '@components/buttons/button/button.component'
import localForageHelper from '@helpers/localforage.helper'
import onSocialNetworkConnection from '@observables/social-network-connection.observable'
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ChecklistComponent, { ItemList } from '../checklist/checklist.component'
import HeaderComponent from '../error-vinculate/components/header/header.component'

import './success-vinculate.component.scoped.scss'

export interface ProfileBinded {
  id: string
  picture: string
  username: string
}

interface Props {
  height: number
  width: number
  profileBinded?: ProfileBinded
  onCloseModal: () => Promise<void>
  socialNetwork: SocialNetworksAvailables
  user: User
}

export default ({ height, width, onCloseModal, profileBinded, socialNetwork, user }: Props) => {
  const [isProfileRenewed, setIsProfileRenewed] = useState(false)
  const actionsContainer = useRef<HTMLDivElement>(null)
  const modalContainer = useRef<HTMLDivElement>(null)

  const { t } = useTranslation('modalVinculateSocialNetwork')

  const list: ItemList[] = [
    { message: t('modalSuccess.profileIsBusiness'), status: 'success' },
    { message: t('modalSuccess.pageConnected'), status: 'success' },
    { message: t('modalSuccess.facebookConnectionIsOk'), status: 'success' },
  ]

  const handleSocialNetworksPage = useCallback(async () => {
    const profileId = profileBinded?.id
    await onCloseModal()
    const toPath = '/profile/social-networks'
    history.pushState({ openCategoryForProfileId: profileId }, '', toPath)
  }, [onCloseModal, profileBinded?.id])

  const addOtherProfile = useCallback(async () => {
    await onCloseModal()
    onSocialNetworkConnection.next({ connect: true })
  }, [onCloseModal])

  useEffect(() => {
    const checkIfProfileIsRenewed = async () => {
      const idProfileRenewed = await localForageHelper.getItem('idProfileRenewed')
      setIsProfileRenewed(!!idProfileRenewed)
    }

    checkIfProfileIsRenewed()
  }, [profileBinded?.username, socialNetwork])

  useLayoutEffect(() => {
    const resize = () => {
      if (actionsContainer.current && modalContainer.current) {
        const borderTop = 28
        const borderBottom = 42
        modalContainer.current.style.height = `calc(100% - ${actionsContainer.current.clientHeight + borderTop + borderBottom}px)`
      }
    }
    window.addEventListener('resize', () => resize())
    resize()
    return () => window.removeEventListener('resize', resize)
  })

  return (
    <div
      className="success-vinculate"
      style={{
        height: width < 991 ? `calc(${height}px - 2px)` : null,
      }}
    >
      <div className="content-modal" ref={modalContainer}>
        <p className="h-1 message-success white" dangerouslySetInnerHTML={{ __html: t('modalSuccess.title') }} />
      </div>
      <div className="actions-container" ref={actionsContainer}>
        {isProfileRenewed ? (
          <div>
            <HeaderComponent profileBinded={profileBinded} socialNetwork={socialNetwork} />
            <ChecklistComponent checkList={list} />
          </div>
        ) : null}
        {!isProfileRenewed ? <p className="description px-1" dangerouslySetInnerHTML={{ __html: t('modalSuccess.description') }} /> : null}
        <div className="actions">
          {!isProfileRenewed ? (
            <div>
              <Button width="100%" onClick={async () => await handleSocialNetworksPage()}>
                {t('modalSuccess.buttonLetsGo')}
              </Button>
              <Button
                width="100%"
                color="transparent"
                borderColor="transparent"
                textColor="var(--primary_color)"
                onClick={() => handleSocialNetworksPage()}
              >
                <span className="label-button">{t('toGoConnections')}</span>
              </Button>
            </div>
          ) : null}
          {isProfileRenewed ? (
            <div>
              <Button width="100%" onClick={async () => await handleSocialNetworksPage()}>
                {t('modalSuccess.configCategories')}
              </Button>
              <Button
                width="100%"
                color="transparent"
                borderColor="transparent"
                textColor="var(--primary_color)"
                onClick={() => handleSocialNetworksPage()}
              >
                <span className="label-button" dangerouslySetInnerHTML={{ __html: t('toGoConnections') }} />
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
